(function() {
    'use strict';
    angular
        .module('sigmasfApp')
        .factory('ChangeTable', ChangeTable);

    ChangeTable.$inject = ['$resource'];

    function ChangeTable ($resource) {
        var resourceUrl =  'api/change-tables/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
